import { getResponsiveProp, responsive } from '../helpers';
export function responsiveFlexStyle() {
    return [
        flexBaseStyle,
        responsiveFlexAlignStyle,
        responsiveFlexWrapStyle,
        responsiveFlexJustifyStyle,
        responsiveFlexDirectionStyle,
    ];
}
function flexBaseStyle() {
    return { '&:not([hidden])': { display: 'flex' } };
}
export function responsiveFlexAlignStyle(props) {
    const { theme } = props;
    const { media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$align), (align) => {
        return { alignItems: align };
    });
}
export function responsiveFlexWrapStyle(props) {
    const { theme } = props;
    const { media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$wrap), (wrap) => {
        return { flexWrap: wrap };
    });
}
export function responsiveFlexJustifyStyle(props) {
    const { theme } = props;
    const { media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$justify), (justify) => {
        return { justifyContent: justify };
    });
}
export function responsiveFlexDirectionStyle(props) {
    const { theme } = props;
    const { media } = theme.sanity;
    return responsive(media, getResponsiveProp(props.$direction), (direction) => {
        return { flexDirection: direction };
    });
}
//# sourceMappingURL=flexStyle.js.map